export const attachmentsLabels = [
    { value: 'quote', label: 'DEAL_DETAIL:SELECT_QUOTE' },
    { value: 'offer', label: 'DEAL_DETAIL:SELECT_OFFER' },
    { value: 'contract', label: 'DEAL_DETAIL:SELECT_CONTRACT' },
    { value: 'other', label: 'DEAL_DETAIL:SELECT_OTHER' },
]